import { Invoice, InvoiceItem } from "@lib/types/Billing";
import {
  StyledAddItem,
  StyledInvoicePriceSummary,
  StyledInvoiceFooterTotalPrice,
} from "./index.styled";
import { Descriptions } from "antd";
import { FaPlus } from "react-icons/fa";
import useIntl from "react-intl/lib/src/components/useIntl";
import CoinPriceTextFormat from "../Others/CoinPriceTextFormat";

type Props = {
  items: InvoiceItem[];
  setItems: (items: InvoiceItem[]) => void;
  invoice?: Invoice;
  itemsTotalAmount: number;
  itemsTotalDiscount: number;
  itemsTotalWithoutDiscountAmount: number;
  isEditMode: boolean;
};

export default function InvoicePriceSummary(props: Props) {
  const {
    setItems,
    items,
    invoice,
    itemsTotalAmount,
    itemsTotalDiscount,
    itemsTotalWithoutDiscountAmount,
    isEditMode,
  } = props;
  const { messages } = useIntl();

  return (
    <StyledInvoicePriceSummary id="invoice-price-summary">
      {isEditMode && (
        <StyledAddItem
          id="invoice-add-item-button"
          onClick={() =>
            setItems([
              ...items,
              {
                id: null,
                unitPrice: 0,
                discount: 0,
                quantity: 1,
              } as InvoiceItem,
            ])
          }
        >
          <FaPlus size={18} />
          <div style={{ marginLeft: 6, fontSize: 16 }}>
            {messages["common.addItem"] as string}
          </div>
        </StyledAddItem>
      )}

      <StyledInvoiceFooterTotalPrice>
        <Descriptions bordered column={1} size="small" className="custom">
          <Descriptions.Item
            label={messages["common.totalWithoutDiscount"] as string}
          >
            <CoinPriceTextFormat
              amount={itemsTotalWithoutDiscountAmount}
              showCurrency={invoice?.currency}
              showCurrencyImage
              bold
            />
          </Descriptions.Item>

          <Descriptions.Item label={messages["common.totalDiscount"] as string}>
            <CoinPriceTextFormat
              amount={itemsTotalDiscount}
              showCurrency={invoice?.currency}
              showCurrencyImage
              bold
            />
          </Descriptions.Item>

          <Descriptions.Item label={messages["common.grandTotal"] as string}>
            <CoinPriceTextFormat
              amount={itemsTotalAmount}
              showCurrency={invoice?.currency}
              showCurrencyImage
              bold
            />
          </Descriptions.Item>

          {invoice && (
            <Descriptions.Item label={messages["common.paid"] as string}>
              <CoinPriceTextFormat
                amount={invoice?.paid || 0}
                showCurrency={invoice?.currency}
                showCurrencyImage
                bold
              />
            </Descriptions.Item>
          )}

          {invoice && (
            <Descriptions.Item
              label={messages["common.remainingAmount"] as string}
            >
              <CoinPriceTextFormat
                amount={invoice?.remainingAmount || 0}
                showCurrency={invoice?.currency}
                showCurrencyImage
                bold
              />
            </Descriptions.Item>
          )}
        </Descriptions>
      </StyledInvoiceFooterTotalPrice>
    </StyledInvoicePriceSummary>
  );
}
